import React from 'react';
import cn from 'classnames';
import { Link, Route } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import FinanceNews from './FinanceNews';

interface Props {
  className?: string;
}

const FinanceMain: React.FC<Props> = ({ className }) => {
  const NotLaunching = () => {
    window.alert('Not Launching Page');
  };
  return (
    <div
      className={cn(
        className,
        'min-h-screen max-w-screen-lg text-center pt-20 text-black mx-auto',
      )}>
      <div className="text-xs space-x-6">
        <Link to="/finance/news">
          <Button>NEWS</Button>
        </Link>
        <Link to="/finance/popluar">
          <Button onClick={() => NotLaunching()}>POPULAR</Button>
        </Link>
        <Link to="/finance/nothing">
          <Button onClick={() => NotLaunching()}>NOTHING</Button>
        </Link>
      </div>
      <div className="px-6">
        <Route path="/finance/news" component={FinanceNews} />
        {/* <Route path="/finance/correlation" component={ChartCorrelation} />
        <Route path="/finance/nothing" component={ChartNothing} /> */}
      </div>
    </div>
  );
};

export default FinanceMain;
